import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { FAQ_DATA } from '../../data/mockData';
import SafeIcon from '../../common/SafeIcon';
import { FiPlus, FiMinus, FiHelpCircle } from 'react-icons/fi';

export default function FAQ() {
  const [openIdx, setOpenIdx] = useState(0);

  return (
    <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} className="space-y-6">
      <div>
        <h2 className="text-2xl font-bold text-[var(--pearl)] mb-1">Harbor Support / FAQ</h2>
        <p className="text-[var(--pearl-muted)] text-sm">Everything you need to know about the DataHarbor experience.</p>
      </div>

      <div className="max-w-3xl mx-auto space-y-4">
        {FAQ_DATA.map((faq, i) => (
          <div key={i} className="glass-panel overflow-hidden">
            <button
              onClick={() => setOpenIdx(openIdx === i ? -1 : i)}
              className="w-full p-6 text-left flex items-center justify-between hover:bg-[var(--surface-ocean-light)]/30 transition-colors"
            >
              <div className="flex items-center gap-4">
                <SafeIcon icon={FiHelpCircle} className="text-[var(--schema-teal)] text-xl flex-shrink-0" />
                <span className="font-semibold text-[var(--pearl)]">{faq.question}</span>
              </div>
              <SafeIcon icon={openIdx === i ? FiMinus : FiPlus} className="text-[var(--pearl-muted)]" />
            </button>
            <AnimatePresence>
              {openIdx === i && (
                <motion.div
                  initial={{ height: 0, opacity: 0 }}
                  animate={{ height: 'auto', opacity: 1 }}
                  exit={{ height: 0, opacity: 0 }}
                  className="border-t border-[var(--border-ocean)]"
                >
                  <div className="p-6 text-[var(--pearl-muted)] text-sm leading-relaxed bg-[var(--bg-ocean)]/50">
                    {faq.answer}
                  </div>
                </motion.div>
              )}
            </AnimatePresence>
          </div>
        ))}
        
        <div className="glass-panel p-8 text-center bg-gradient-to-br from-[var(--schema-teal-dim)] to-transparent">
          <h3 className="text-lg font-bold text-[var(--pearl)] mb-2">Still have questions?</h3>
          <p className="text-sm text-[var(--pearl-muted)] mb-6">Our crew is standing by to help you navigate the harbor.</p>
          <button className="btn-primary">Contact Command Center</button>
        </div>
      </div>
    </motion.div>
  );
}